import StandardPaymentMethods from "./StandardPaymentMethods";
import PaymentPaypal from "./PaymentPaypal";
import InvoiceText from "./InvoiceText";
import getStandardPaymentMethodProps from "./selectors";

export { PaymentPaypal, getStandardPaymentMethodProps, InvoiceText };

export default StandardPaymentMethods;
